import React, { Component } from 'react';
import { SQueryList } from '@mpfe/cskit';
import { connect } from 'react-redux';
import ImgContListUI from '../ImgContList/UI';
import Pager from '@mpfe/pager';
import '@mpfe/pager/dist/index.css';
class ImgContList extends Component {
  render() {
    const firstprops = this.props.firstmenu;
    const secprops = this.props.secmenu;
    const firstmenu = firstprops || this.props.location.pathname.split('/')[1];
    const secmenu = secprops || this.props.location.pathname.split('/')[2];
    const language = sessionStorage.getItem('language');
    const { routesMap } = this.props.routes;
    const { pagerOption, onPageChange } = this.props;
    const options = { ...pagerOption, channelNo: secmenu };
    return (
      <>
        <div className="main-title">
          <h3>{routesMap[secmenu] && routesMap[secmenu].channelName}</h3>
        </div>
        <SQueryList options={options} type="QUERY_LIST">
          {props => {
            return (
              <>
                <ImgContListUI
                  data={props.records}
                  firstmenu={firstmenu}
                  secmenu={secmenu}
                  language={language}
                />
                <Pager
                  containerClassName="mypager"
                  pagerClassName="sw-pages"
                  pageCount={props.pageCount}
                  forcePage={pagerOption.currentPage}
                  hrefCreator={page => {
                    return `?page=${page}`;
                  }}
                  onPageChange={page => {
                    onPageChange(page);
                  }}
                ></Pager>
              </>
            );
          }}
        </SQueryList>
      </>
    );
  }
}

export default connect(state => {
  return {
    routes: state.toproutes,
  };
})(ImgContList);
